import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {PaginatedResponse} from '../../interfaces';

@Component({
    selector: 'kkk-pagination',
    templateUrl: './pagination.component.html'
})
export class PaginationComponent implements OnInit {
    public Arr = Array;

    @Input()
    pagination: PaginatedResponse<any>;

    @Input()
    name: string;

    @Input()
    size: string;

    @Input()
    center: boolean;

    @Input()
    hideWhenOnly: boolean;

    @Output()
    pageChange = new EventEmitter();

    @Output()
    pageChangeUrl = new EventEmitter();

    public small: boolean;
    public large: boolean;

    get hidden() {
        return !this.pagination || (this.hideWhenOnly && this.isTheOnlyPage());
    }

    constructor() {
    }

    ngOnInit() {
        this.name = this.name || 'Lapozás';
        this.small = this.size === 'sm';
        this.large = this.size === 'lg';
    }

    isTheOnlyPage() {
        return this.pagination.last_page === 1;
    }

    jumpTo(url: string): void {
        this.pageChangeUrl.emit(url);
        try {
            this.pageChange.emit(url.split('=').pop());
        } catch (error) {
            console.error(error);
        }
    }

    jumpToPage(page: number): void {
        this.pageChange.emit(page);
        this.pageChangeUrl.emit(this.pagination.path + '?page=' + page);
    }

}



// WEBPACK FOOTER //
// /Users/manuel/Development/kkk/frontend/src/app/shared/components/pagination/pagination.component.ts